export function isBefore(date: Date): boolean {
  if (new Date(date).getTime() < new Date().getTime()) return false;

  return true;
}
